import rules from "../../rules";
import { tem, usePermissoes } from "../../suporte/permissoes";

const check = (role, action, data) => {
	const permissions = rules[role];
	if (!permissions) {
		// role is not present in the rules
		return false;
	}

	const staticPermissions = permissions.static;

	if (staticPermissions && staticPermissions.includes(action)) {
		// static rule not provided for action
		return true;
	}

	const dynamicPermissions = permissions.dynamic;

	if (dynamicPermissions) {
		const permissionCondition = dynamicPermissions[action];
		if (!permissionCondition) {
			// dynamic rule not provided for action
			return false;
		}

		return permissionCondition(data);
	}
	return false;
};

// regras antigas do Whaticket → permissões granulares (suporte-app/app/permissoes.py)
const PERMISSAO = {
	"tickets-manager:showall": "tickets.ver_todos",
	"ticket-options:deleteTicket": "tickets.excluir",
	"ticket-options:transferWhatsapp": "tickets.transferir_conexao",
	"contacts-page:deleteContact": "contatos.excluir",
	"user-modal:editProfile": "usuarios.gerenciar",
	"user-modal:editQueues": "usuarios.gerenciar",
	"drawer-admin-items:view": "usuarios.gerenciar",
};

const Can = ({ role, perform, data, yes, no }) => {
	const permissoes = usePermissoes();
	const chave = PERMISSAO[perform];
	// enquanto as permissões não carregam (ou o suporte-app está fora), vale a regra antiga do perfil
	const pode = chave && permissoes ? tem(permissoes, chave) : check(role, perform, data);
	return pode ? yes() : no();
};

Can.defaultProps = {
	yes: () => null,
	no: () => null,
};

export { Can };
